module.exports = {
	"main": {
		"de": {
			"identity": {
				"version": {
					"_cldrVersion": "36"
				},
				"language": "de"
			},
			"dates": {
				"fields": {
					"era": {
						"displayName": "Epoche"
					},
					"era-short": {
						"displayName": "Epoche"
					},
					"era-narrow": {
						"displayName": "E"
					},
					"year": {
						"displayName": "Jahr",
						"relative-type--1": "letztes Jahr",
						"relative-type-0": "dieses Jahr",
						"relative-type-1": "nächstes Jahr",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Jahr",
							"relativeTimePattern-count-other": "in {0} Jahren"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Jahr",
							"relativeTimePattern-count-other": "vor {0} Jahren"
						}
					},
					"year-short": {
						"displayName": "Jahr",
						"relative-type--1": "letztes Jahr",
						"relative-type-0": "dieses Jahr",
						"relative-type-1": "nächstes Jahr",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Jahr",
							"relativeTimePattern-count-other": "in {0} Jahren"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Jahr",
							"relativeTimePattern-count-other": "vor {0} Jahren"
						}
					},
					"year-narrow": {
						"displayName": "J",
						"relative-type--1": "letztes Jahr",
						"relative-type-0": "dieses Jahr",
						"relative-type-1": "nächstes Jahr",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Jahr",
							"relativeTimePattern-count-other": "in {0} Jahren"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Jahr",
							"relativeTimePattern-count-other": "vor {0} Jahren"
						}
					},
					"quarter": {
						"displayName": "Quartal",
						"relative-type--1": "letztes Quartal",
						"relative-type-0": "dieses Quartal",
						"relative-type-1": "nächstes Quartal",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Quartal",
							"relativeTimePattern-count-other": "in {0} Quartalen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Quartal",
							"relativeTimePattern-count-other": "vor {0} Quartalen"
						}
					},
					"quarter-short": {
						"displayName": "Quart.",
						"relative-type--1": "letztes Quartal",
						"relative-type-0": "dieses Quartal",
						"relative-type-1": "nächstes Quartal",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Quart.",
							"relativeTimePattern-count-other": "in {0} Quart."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Quart.",
							"relativeTimePattern-count-other": "vor {0} Quart."
						}
					},
					"quarter-narrow": {
						"displayName": "Q",
						"relative-type--1": "letztes Quartal",
						"relative-type-0": "dieses Quartal",
						"relative-type-1": "nächstes Quartal",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Q",
							"relativeTimePattern-count-other": "in {0} Q"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Q",
							"relativeTimePattern-count-other": "vor {0} Q"
						}
					},
					"month": {
						"displayName": "Monat",
						"relative-type--1": "letzten Monat",
						"relative-type-0": "diesen Monat",
						"relative-type-1": "nächsten Monat",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Monat",
							"relativeTimePattern-count-other": "in {0} Monaten"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Monat",
							"relativeTimePattern-count-other": "vor {0} Monaten"
						}
					},
					"month-short": {
						"displayName": "Monat",
						"relative-type--1": "letzten Monat",
						"relative-type-0": "diesen Monat",
						"relative-type-1": "nächsten Monat",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Monat",
							"relativeTimePattern-count-other": "in {0} Monaten"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Monat",
							"relativeTimePattern-count-other": "vor {0} Monaten"
						}
					},
					"month-narrow": {
						"displayName": "M",
						"relative-type--1": "letzten Monat",
						"relative-type-0": "diesen Monat",
						"relative-type-1": "nächsten Monat",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Monat",
							"relativeTimePattern-count-other": "in {0} Monaten"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Monat",
							"relativeTimePattern-count-other": "vor {0} Monaten"
						}
					},
					"week": {
						"displayName": "Woche",
						"relative-type--1": "letzte Woche",
						"relative-type-0": "diese Woche",
						"relative-type-1": "nächste Woche",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Woche",
							"relativeTimePattern-count-other": "in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Woche",
							"relativeTimePattern-count-other": "vor {0} Wochen"
						},
						"relativePeriod": "die Woche vom {0}"
					},
					"week-short": {
						"displayName": "Woche",
						"relative-type--1": "letzte Woche",
						"relative-type-0": "diese Woche",
						"relative-type-1": "nächste Woche",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Woche",
							"relativeTimePattern-count-other": "in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Woche",
							"relativeTimePattern-count-other": "vor {0} Wochen"
						},
						"relativePeriod": "die Woche vom {0}"
					},
					"week-narrow": {
						"displayName": "W",
						"relative-type--1": "letzte Woche",
						"relative-type-0": "diese Woche",
						"relative-type-1": "nächste Woche",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Wo.",
							"relativeTimePattern-count-other": "in {0} Wo."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Wo.",
							"relativeTimePattern-count-other": "vor {0} Wo."
						},
						"relativePeriod": "die Woche vom {0}"
					},
					"weekOfMonth": {
						"displayName": "Woche des Monats"
					},
					"weekOfMonth-short": {
						"displayName": "W/M"
					},
					"weekOfMonth-narrow": {
						"displayName": "Wo. des Monats"
					},
					"day": {
						"displayName": "Tag",
						"relative-type--2": "vorgestern",
						"relative-type--1": "gestern",
						"relative-type-0": "heute",
						"relative-type-1": "morgen",
						"relative-type-2": "übermorgen",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Tag",
							"relativeTimePattern-count-other": "in {0} Tagen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Tag",
							"relativeTimePattern-count-other": "vor {0} Tagen"
						}
					},
					"day-short": {
						"displayName": "Tag",
						"relative-type--2": "vorgestern",
						"relative-type--1": "gestern",
						"relative-type-0": "heute",
						"relative-type-1": "morgen",
						"relative-type-2": "übermorgen",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Tag",
							"relativeTimePattern-count-other": "in {0} Tagen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Tag",
							"relativeTimePattern-count-other": "vor {0} Tagen"
						}
					},
					"day-narrow": {
						"displayName": "Tag",
						"relative-type--2": "vorgestern",
						"relative-type--1": "gestern",
						"relative-type-0": "heute",
						"relative-type-1": "morgen",
						"relative-type-2": "übermorgen",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Tag",
							"relativeTimePattern-count-other": "in {0} Tagen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Tag",
							"relativeTimePattern-count-other": "vor {0} Tagen"
						}
					},
					"dayOfYear": {
						"displayName": "Tag des Jahres"
					},
					"dayOfYear-short": {
						"displayName": "Tag des Jahres"
					},
					"dayOfYear-narrow": {
						"displayName": "T/J"
					},
					"weekday": {
						"displayName": "Wochentag"
					},
					"weekday-short": {
						"displayName": "Wochentag"
					},
					"weekday-narrow": {
						"displayName": "Wochent."
					},
					"weekdayOfMonth": {
						"displayName": "Wochentag"
					},
					"weekdayOfMonth-short": {
						"displayName": "Wochentag"
					},
					"weekdayOfMonth-narrow": {
						"displayName": "WT"
					},
					"sun": {
						"relative-type--1": "letzten Sonntag",
						"relative-type-0": "diesen Sonntag",
						"relative-type-1": "nächsten Sonntag",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Sonntag in {0} Woche",
							"relativeTimePattern-count-other": "Sonntag in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Sonntag vor {0} Woche",
							"relativeTimePattern-count-other": "Sonntag vor {0} Wochen"
						}
					},
					"sun-short": {
						"relative-type--1": "letzten So.",
						"relative-type-0": "diesen So.",
						"relative-type-1": "nächsten So.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "So. in {0} Woche",
							"relativeTimePattern-count-other": "So. in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "So. vor {0} Woche",
							"relativeTimePattern-count-other": "So. vor {0} Wochen"
						}
					},
					"sun-narrow": {
						"relative-type--1": "letzten So.",
						"relative-type-0": "diesen So.",
						"relative-type-1": "nächsten So.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "So. in {0} W.",
							"relativeTimePattern-count-other": "So. in {0} W."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "So. vor {0} W.",
							"relativeTimePattern-count-other": "So. vor {0} W."
						}
					},
					"mon": {
						"relative-type--1": "letzten Montag",
						"relative-type-0": "diesen Montag",
						"relative-type-1": "nächsten Montag",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Montag in {0} Woche",
							"relativeTimePattern-count-other": "Montag in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Montag vor {0} Woche",
							"relativeTimePattern-count-other": "Montag vor {0} Wochen"
						}
					},
					"mon-short": {
						"relative-type--1": "letzten Mo.",
						"relative-type-0": "diesen Mo.",
						"relative-type-1": "nächsten Mo.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Mo. in {0} Woche",
							"relativeTimePattern-count-other": "Mo. in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Mo. vor {0} Woche",
							"relativeTimePattern-count-other": "Mo. vor {0} Wochen"
						}
					},
					"mon-narrow": {
						"relative-type--1": "letzten Mo.",
						"relative-type-0": "diesen Mo.",
						"relative-type-1": "nächsten Mo.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Mo. in {0} W.",
							"relativeTimePattern-count-other": "Mo. in {0} W."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Mo. vor {0} W.",
							"relativeTimePattern-count-other": "Mo. vor {0} W."
						}
					},
					"tue": {
						"relative-type--1": "letzten Dienstag",
						"relative-type-0": "diesen Dienstag",
						"relative-type-1": "nächsten Dienstag",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Dienstag in {0} Woche",
							"relativeTimePattern-count-other": "Dienstag in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Dienstag vor {0} Woche",
							"relativeTimePattern-count-other": "Dienstag vor {0} Wochen"
						}
					},
					"tue-short": {
						"relative-type--1": "letzten Di.",
						"relative-type-0": "diesen Di.",
						"relative-type-1": "nächsten Di.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Di. in {0} Woche",
							"relativeTimePattern-count-other": "Di. in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Di. vor {0} Woche",
							"relativeTimePattern-count-other": "Di. vor {0} Wochen"
						}
					},
					"tue-narrow": {
						"relative-type--1": "letzten Di.",
						"relative-type-0": "diesen Di.",
						"relative-type-1": "nächsten Di.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Di. in {0} W.",
							"relativeTimePattern-count-other": "Di. in {0} W."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Di. vor {0} W.",
							"relativeTimePattern-count-other": "Di. vor {0} W."
						}
					},
					"wed": {
						"relative-type--1": "letzten Mittwoch",
						"relative-type-0": "diesen Mittwoch",
						"relative-type-1": "nächsten Mittwoch",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Mittwoch in {0} Woche",
							"relativeTimePattern-count-other": "Mittwoch in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Mittwoch vor {0} Woche",
							"relativeTimePattern-count-other": "Mittwoch vor {0} Wochen"
						}
					},
					"wed-short": {
						"relative-type--1": "letzten Mi.",
						"relative-type-0": "diesen Mi.",
						"relative-type-1": "nächsten Mi.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Mi. in {0} Woche",
							"relativeTimePattern-count-other": "Mi. in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Mi. vor {0} Woche",
							"relativeTimePattern-count-other": "Mi. vor {0} Wochen"
						}
					},
					"wed-narrow": {
						"relative-type--1": "letzten Mi.",
						"relative-type-0": "diesen Mi.",
						"relative-type-1": "nächsten Mi.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Mi. in {0} W.",
							"relativeTimePattern-count-other": "Mi. in {0} W."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Mi. vor {0} W.",
							"relativeTimePattern-count-other": "Mi. vor {0} W."
						}
					},
					"thu": {
						"relative-type--1": "letzten Donnerstag",
						"relative-type-0": "diesen Donnerstag",
						"relative-type-1": "nächsten Donnerstag",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Donnerstag in {0} Woche",
							"relativeTimePattern-count-other": "Donnerstag in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Donnerstag vor {0} Woche",
							"relativeTimePattern-count-other": "Donnerstag vor {0} Wochen"
						}
					},
					"thu-short": {
						"relative-type--1": "letzten Do.",
						"relative-type-0": "diesen Do.",
						"relative-type-1": "nächsten Do.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Do. in {0} Woche",
							"relativeTimePattern-count-other": "Do. in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Do. vor {0} Woche",
							"relativeTimePattern-count-other": "Do. vor {0} Wochen"
						}
					},
					"thu-narrow": {
						"relative-type--1": "letzten Do.",
						"relative-type-0": "diesen Do.",
						"relative-type-1": "nächsten Do.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Do. in {0} W.",
							"relativeTimePattern-count-other": "Do. in {0} W."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Do. vor {0} W.",
							"relativeTimePattern-count-other": "Do. vor {0} W."
						}
					},
					"fri": {
						"relative-type--1": "letzten Freitag",
						"relative-type-0": "diesen Freitag",
						"relative-type-1": "nächsten Freitag",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Freitag in {0} Woche",
							"relativeTimePattern-count-other": "Freitag in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Freitag vor {0} Woche",
							"relativeTimePattern-count-other": "Freitag vor {0} Wochen"
						}
					},
					"fri-short": {
						"relative-type--1": "letzten Fr.",
						"relative-type-0": "diesen Fr.",
						"relative-type-1": "nächsten Fr.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Fr. in {0} Woche",
							"relativeTimePattern-count-other": "Fr. in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Fr. vor {0} Woche",
							"relativeTimePattern-count-other": "Fr. vor {0} Wochen"
						}
					},
					"fri-narrow": {
						"relative-type--1": "letzten Fr.",
						"relative-type-0": "diesen Fr.",
						"relative-type-1": "nächsten Fr.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Fr. in {0} W.",
							"relativeTimePattern-count-other": "Fr. in {0} W."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Fr. vor {0} W.",
							"relativeTimePattern-count-other": "Fr. vor {0} W."
						}
					},
					"sat": {
						"relative-type--1": "letzten Samstag",
						"relative-type-0": "diesen Samstag",
						"relative-type-1": "nächsten Samstag",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Samstag in {0} Woche",
							"relativeTimePattern-count-other": "Samstag in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Samstag vor {0} Woche",
							"relativeTimePattern-count-other": "Samstag vor {0} Wochen"
						}
					},
					"sat-short": {
						"relative-type--1": "letzten Sa.",
						"relative-type-0": "diesen Sa.",
						"relative-type-1": "nächsten Sa.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Sa. in {0} Woche",
							"relativeTimePattern-count-other": "Sa. in {0} Wochen"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Sa. vor {0} Woche",
							"relativeTimePattern-count-other": "Sa. vor {0} Wochen"
						}
					},
					"sat-narrow": {
						"relative-type--1": "letzten Sa.",
						"relative-type-0": "diesen Sa.",
						"relative-type-1": "nächsten Sa.",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "Sa. in {0} W.",
							"relativeTimePattern-count-other": "Sa. in {0} W."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "Sa. vor {0} W.",
							"relativeTimePattern-count-other": "Sa. vor {0} W."
						}
					},
					"dayperiod-short": {
						"displayName": "Tageshälfte"
					},
					"dayperiod": {
						"displayName": "Tageshälfte"
					},
					"dayperiod-narrow": {
						"displayName": "Tagesh."
					},
					"hour": {
						"displayName": "Stunde",
						"relative-type-0": "in dieser Stunde",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Stunde",
							"relativeTimePattern-count-other": "in {0} Stunden"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Stunde",
							"relativeTimePattern-count-other": "vor {0} Stunden"
						}
					},
					"hour-short": {
						"displayName": "Std.",
						"relative-type-0": "in dieser Stunde",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Std.",
							"relativeTimePattern-count-other": "in {0} Std."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Std.",
							"relativeTimePattern-count-other": "vor {0} Std."
						}
					},
					"hour-narrow": {
						"displayName": "Std.",
						"relative-type-0": "in dieser Stunde",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Std.",
							"relativeTimePattern-count-other": "in {0} Std."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Std.",
							"relativeTimePattern-count-other": "vor {0} Std."
						}
					},
					"minute": {
						"displayName": "Minute",
						"relative-type-0": "in dieser Minute",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Minute",
							"relativeTimePattern-count-other": "in {0} Minuten"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Minute",
							"relativeTimePattern-count-other": "vor {0} Minuten"
						}
					},
					"minute-short": {
						"displayName": "Min.",
						"relative-type-0": "in dieser Minute",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Min.",
							"relativeTimePattern-count-other": "in {0} Min."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Min.",
							"relativeTimePattern-count-other": "vor {0} Min."
						}
					},
					"minute-narrow": {
						"displayName": "Min.",
						"relative-type-0": "in dieser Minute",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} m",
							"relativeTimePattern-count-other": "in {0} m"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} m",
							"relativeTimePattern-count-other": "vor {0} m"
						}
					},
					"second": {
						"displayName": "Sekunde",
						"relative-type-0": "jetzt",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Sekunde",
							"relativeTimePattern-count-other": "in {0} Sekunden"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Sekunde",
							"relativeTimePattern-count-other": "vor {0} Sekunden"
						}
					},
					"second-short": {
						"displayName": "Sek.",
						"relative-type-0": "jetzt",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} Sek.",
							"relativeTimePattern-count-other": "in {0} Sek."
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} Sek.",
							"relativeTimePattern-count-other": "vor {0} Sek."
						}
					},
					"second-narrow": {
						"displayName": "Sek.",
						"relative-type-0": "jetzt",
						"relativeTime-type-future": {
							"relativeTimePattern-count-one": "in {0} s",
							"relativeTimePattern-count-other": "in {0} s"
						},
						"relativeTime-type-past": {
							"relativeTimePattern-count-one": "vor {0} s",
							"relativeTimePattern-count-other": "vor {0} s"
						}
					},
					"zone": {
						"displayName": "Zeitzone"
					},
					"zone-short": {
						"displayName": "Zeitzone"
					},
					"zone-narrow": {
						"displayName": "Zeitz."
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/cldr-dates-full@36.0.0_cldr-numbers-full@36.0.0_cldr-core@36.0.0_/~/cldr-dates-full/main/de/dateFields.json
// module id = 6796
// module chunks = 0